var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashierHubIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 17.75V6.47222L10 3.25L17.25 6.47222V17.75M10.8056 10.7877H14.0278V17.2321H5.97222V12.3988H10.8056M10.8056 17.2321V9.98214C10.8056 9.7685 10.7207 9.5636 10.5696 9.41253C10.4185 9.26146 10.2136 9.17659 10 9.17659H8.38889C8.17524 9.17659 7.97035 9.26146 7.81927 9.41253C7.6682 9.5636 7.58333 9.7685 7.58333 9.98214V12.3988",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashierHubIcon);
export default __webpack_public_path__ + "654b3bad91db27143464c6b657d5d69b.svg";
export { ForwardRef as ReactComponent };